import getTranslation from './getTranslation';

// Create native dialog element and add to DOM when page loads
function createNoConnectionModal() {
  const dialogHtml = `
    <dialog id="no-connection-dialog" class="no-connection-dialog">
      <div class="no-connection-dialog-content">
        <div class="no-connection-dialog-header">
          <h3 id="no-connection-title">${getTranslation('let_op')}</h3>
          <button class="no-connection-close-btn" aria-label="Close">&times;</button>
        </div>
        <div class="no-connection-dialog-body">
          <p id="no-connection-message">${getTranslation('geen_verbinding')}</p>
        </div>
        <div class="no-connection-dialog-footer">
          <button class="no-connection-ok-btn">${getTranslation('ok') || 'OK'}</button>
        </div>
      </div>
    </dialog>
  `;

  // Add dialog to DOM
  document.body.insertAdjacentHTML('beforeend', dialogHtml);

  // Add CSS styles for native dialog
  const styles = `
    <style>
      .no-connection-dialog {
        max-width: 400px;
        width: 90%;
        border: none;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
        padding: 0;
        animation: dialogFadeIn 0.3s ease-out;
      }

      .no-connection-dialog::backdrop {
        background-color: rgba(0, 0, 0, 0.5);
      }

      @keyframes dialogFadeIn {
        from {
          opacity: 0;
          transform: scale(0.9) translateY(-20px);
        }
        to {
          opacity: 1;
          transform: scale(1) translateY(0);
        }
      }

      .no-connection-dialog-content {
        background: white;
        border-radius: 8px;
        overflow: hidden;
      }

      .no-connection-dialog-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 20px;
        border-bottom: 1px solid #e1e5e9;
        background-color: #f8f9fa;
      }

      .no-connection-dialog-header h3 {
        margin: 0;
        color: #dc3545;
        font-size: 18px;
        font-weight: 600;
      }

      .no-connection-close-btn {
        background: none;
        border: none;
        font-size: 24px;
        color: #6c757d;
        cursor: pointer;
        padding: 0;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        transition: background-color 0.2s;
      }

      .no-connection-close-btn:hover {
        background-color: #e9ecef;
        color: #495057;
      }

      .no-connection-dialog-body {
        padding: 20px;
      }

      .no-connection-dialog-body p {
        margin: 0;
        color: #495057;
        line-height: 1.5;
      }

      .no-connection-dialog-footer {
        padding: 16px 20px;
        border-top: 1px solid #e1e5e9;
        background-color: #f8f9fa;
        text-align: right;
      }

      .no-connection-ok-btn {
        background-color: #007bff;
        color: white;
        border: none;
        padding: 8px 16px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        transition: background-color 0.2s;
      }

      .no-connection-ok-btn:hover {
        background-color: #0056b3;
      }
    </style>
  `;

  // Add styles to head
  document.head.insertAdjacentHTML('beforeend', styles);

  // Add event listeners
  const dialog = document.getElementById(
    'no-connection-dialog'
  ) as HTMLDialogElement;
  const closeBtn = dialog.querySelector('.no-connection-close-btn')!;
  const okBtn = dialog.querySelector('.no-connection-ok-btn')!;

  const closeDialog = () => {
    dialog.close();
  };

  closeBtn.addEventListener('click', closeDialog);
  okBtn.addEventListener('click', closeDialog);

  // Close on backdrop click
  dialog.addEventListener('click', e => {
    const rect = dialog.getBoundingClientRect();
    const isInDialog =
      rect.top <= e.clientY &&
      e.clientY <= rect.top + rect.height &&
      rect.left <= e.clientX &&
      e.clientX <= rect.left + rect.width;
    if (!isInDialog) {
      closeDialog();
    }
  });
}

function noConnection(textStatus: string, errorThrown: Error | string) {
  console.log('Status: ' + textStatus);
  console.log('Error: ' + errorThrown);

  const dialog = document.getElementById(
    'no-connection-dialog'
  ) as HTMLDialogElement;
  if (dialog) {
    dialog.showModal();
  }
}

// Initialize modal when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', createNoConnectionModal);
} else {
  createNoConnectionModal();
}

// Add to global scope
(window as any).noConnection = noConnection;
